import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const CONSENT_KEY = 'knowit_cookie_consent';

function getAnalyticsConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Boolean(parsed.analytics);
  } catch {
    return false;
  }
}

export default function GoogleAnalyticsTracker({ measurementId }) {
  const location = useLocation();
  const [analyticsAllowed, setAnalyticsAllowed] = useState(getAnalyticsConsent());

  useEffect(() => {
    const onConsentUpdate = (event) => {
      if (typeof event?.detail?.analytics === 'boolean') {
        setAnalyticsAllowed(event.detail.analytics);
      } else {
        setAnalyticsAllowed(getAnalyticsConsent());
      }
    };

    const onStorage = (event) => {
      if (event.key === CONSENT_KEY) {
        setAnalyticsAllowed(getAnalyticsConsent());
      }
    };

    window.addEventListener('cookie-consent-updated', onConsentUpdate);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('cookie-consent-updated', onConsentUpdate);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    if (!measurementId) return;

    window[`ga-disable-${measurementId}`] = !analyticsAllowed;
    if (!analyticsAllowed) return;

    if (!document.querySelector(`script[data-ga-loader="${measurementId}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
      script.setAttribute('data-ga-loader', measurementId);
      document.head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      anonymize_ip: true,
      page_path: `${location.pathname}${location.search}`,
    });
  }, [measurementId, analyticsAllowed, location.pathname, location.search]);

  return null;
}
